module.exports = __webpack_public_path__ + "img/demo2.9698a48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zj/demo2.png
// module id = jKdw
// module chunks = 35 36